import { CommonModule, registerLocaleData } from '@angular/common';
import frCH from '@angular/common/locales/fr-CH';
import { NgModule } from '@angular/core';
import { ProductsComponent } from './products/products.component';
import { ProductsRoutingModule } from './products-routing.module';
import { CartModule } from '@mkp/cart/state';
import { CreditStatusModule } from '@mkp/credit/feature-credit-status';
import { ProductComparisonTableComponent } from '@mkp/product/feature-product-comparison-table';
import {
  ProductDisplayButtonSwitchOfferingsComponent,
  ProductDisplayCardListComponent,
  ProductDisplayReadOnlyComponent,
} from '@mkp/product/feature-product-display';
import { ProductTableComponent } from '@mkp/product/feature-product-table';
import { ProductOptionsStateModule } from '@mkp/product-options/state';
import { AssetComponent } from '@mkp/shared/ui-asset';
import { ButtonComponent } from '@mkp/shared/ui-library';

registerLocaleData(frCH, 'fr-CH');

@NgModule({
  imports: [
    CommonModule,
    AssetComponent,
    ButtonComponent,
    CreditStatusModule,
    CartModule,
    ProductOptionsStateModule,
    ProductsComponent,
    ProductsRoutingModule,
    ProductComparisonTableComponent,
    ProductDisplayButtonSwitchOfferingsComponent,
    ProductDisplayCardListComponent,
    ProductDisplayButtonSwitchOfferingsComponent,
    ProductTableComponent,
    ProductDisplayReadOnlyComponent,
  ],
  exports: [ProductsComponent],
})
export class ProductsModule {}
